var map = {
	"./np_fan.svg": "2fcf",
	"./np_fan_green.svg": "d4e6",
	"./np_notification.svg": "8a46",
	"./np_pin.svg": "c065",
	"./np_pin_warning.svg": "ef2e",
	"./room-icons/attic.svg": "7194",
	"./room-icons/baby-room.svg": "dd75",
	"./room-icons/basement.svg": "1e78",
	"./room-icons/bath-room.svg": "5fc0",
	"./room-icons/bedroom.svg": "925e",
	"./room-icons/child-room.svg": "1e77",
	"./room-icons/dining-room.svg": "0add",
	"./room-icons/garage.svg": "c07a",
	"./room-icons/kitchen.svg": "9197",
	"./room-icons/laundry-room.svg": "4988",
	"./room-icons/living-room.svg": "d3aa",
	"./room-icons/master-bedroom.svg": "8c77",
	"./room-icons/office.svg": "d97b",
	"./room-icons/playroom.svg": "950e",
	"./room-icons/storage-room.svg": "d8aa",
	"./room-icons/toilet.svg": "7e88",
	"./room-icons/veranda.svg": "ff93",
	"./room-icons/wardrobe.svg": "5480",
	"./ventilation_unit.svg": "d94f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5349";